




import Vue from "vue";
import { UserService } from "../services";
export default Vue.extend({
  async mounted() {
    await this.logout();
  },
  methods: {
    logout: async function () {
      try {
        //      await this.$store.dispatch("logout");
        const self = this;
        await UserService.userLogout();
        self.$router.replace({ name: "login" });
      } catch (error: any) {
        console.log("error logging out", error);
        this.$router.replace({ name: "error" });
      }
    }
  }
});
